"use strict";
/**
 * @name InputControl
 *
 * @description
 *  The InputControl component is used internally to render Checkbox, Radio and Toggles.  The Checkbox, Radio and
 *  Toggle components should be used instead.  See <Radio />, <Checkbox /> or <Toggle /> for more information.
 *
 * @example
 *  <InputControl name='example' type='radio' label='Check Me' isInline />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var types_1 = require("../../types");
var propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.node,
    group: PropTypes.string,
    inputProps: PropTypes.any,
    labelProps: PropTypes.object,
    isInline: PropTypes.bool,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
};
var InputControl = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, group = _a.group, type = _a.type, inputProps = _a.inputProps, labelProps = _a.labelProps, isInline = _a.isInline, className = _a.className, mods = _a.mods, style = _a.style, testId = _a.testId, otherProps = _a.otherProps, rest = __rest(_a, ["id", "name", "label", "group", "type", "inputProps", "labelProps", "isInline", "className", "mods", "style", "testId", "otherProps"]);
    var classes = (0, helpers_1.getClassName)(className, isInline && 'Checkbox--inline', mods);
    // booleans can skip the extra checking here
    // handle checkboxstates as a valid input
    var value;
    if (inputProps.checked !== undefined) {
        if (typeof inputProps.checked === 'boolean') {
            value = inputProps.checked;
        }
        else if (inputProps.checked === types_1.CheckboxStates.INDETERMINATE) {
            value = true;
        }
        else {
            value = inputProps.checked === 'true';
        }
    }
    var inputId = id || name;
    return (React.createElement("div", __assign({ className: classes, style: style }, otherProps, rest, { "data-testid": testId }),
        React.createElement("input", __assign({ className: "Checkbox-input", type: type, name: group || name, "data-testid": "".concat(name, "-input"), id: inputId }, inputProps, { checked: value })),
        React.createElement("label", __assign({ className: "Checkbox-label", htmlFor: inputId }, labelProps), label)));
};
InputControl.defaultProps = {
    label: null,
    group: null,
    inputProps: {},
    labelProps: {},
    isInline: false,
    className: null,
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = InputControl;
